import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { range } from 'lodash';

class ResultsPaginator extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      totalPages,
      selectedPage,
      onChangePage,
    } = this.props;

    const numPages = Math.ceil(totalPages || 0);
    const pageRange = range(numPages);
    const nextPage = selectedPage + 1;
    const prevPage = selectedPage - 1;
    const lastPage = pageRange[pageRange.length - 1] + 1;

    const max = 6;

    const pageIconCount = (numPages <= max)
      ? numPages
      : max;

    let paginatorItems = range(pageIconCount);

    if (selectedPage < max) {
      // take 1-9 + numPages
      paginatorItems = paginatorItems.map((el, idx) => {
        if (idx === paginatorItems.length - 1) {
          return numPages;
        }
        return idx + 1;
      });
    } else if (selectedPage >= numPages - (max + 2)) {
      // 1 + take currPage - max   (ex: 14)
      // 1 + take curr Page - max  (ex 10) with 12
      paginatorItems = paginatorItems.map((el, idx) => {
        if (idx === paginatorItems.length - 1) {
          return 1;
        }
        return numPages - idx;
      }).reverse();
    } else {
      // ex case 13
      // 1.. (1-4 range) currPage (1-4 range)..max
      // 1,...  9, 10, 11, 12, 13, 14, 15, 16, 17, ..22
      paginatorItems = paginatorItems.map((el, idx) => {
        if (idx === 0) {
          return 1;
        }
        if (idx === paginatorItems.length - 1) {
          return numPages;
        }
        return (selectedPage + idx) - 3;
      });
    }

    paginatorItems = paginatorItems.reduce((accum, el, idx) => {
      const key = `paginator-item${idx}`;
      const item = { page: el, active: (selectedPage === el) };
      const clsName = (item.active)
        ? 'active item'
        : 'item';

      if (idx !== 0 && paginatorItems[idx - 1] !== paginatorItems[idx] - 1) {
        return accum.concat([
          <span
            className="item"
            key={`${key}-ellipse`}
            title="Go to a specific page"
            onClick={() => {
              let extraMessage = '';
              let newPage = selectedPage;
              do {
                newPage = prompt(`${extraMessage}Goto which page (1 - ${lastPage})?`, newPage);
                // on cancel, just quit
                if (!newPage) return;

                if (isNaN(newPage)) extraMessage = `'${newPage}' is not a number!\n\n`;
                else if (newPage > lastPage) extraMessage = `Page ${newPage} does not exist!\n\n`;
                else extraMessage = '';
              } while (extraMessage);
              onChangePage(newPage - 1);
            }}
          >
            ...
          </span>,
          <span
            key={key}
            className={clsName}
            onClick={() => {
              onChangePage(el - 1);
            }}>
            { el }
          </span>,
        ]);
      }
      return accum.concat([
        <span
          key={key}
          className={clsName}
          onClick={() => {
            onChangePage(el - 1);
          }}>
          { el }
        </span>,
      ]);
    }, []);

    const paginator = paginatorItems;

    return (
      <div className="docket docket-pagination" style={{ textAlign: 'center' }}>
        <div className="ui small borderless menu" id="docket-toolbar">
          <div className={`item ${(selectedPage === 1) ? 'disabled' : ''}`}
             title="Go to previous page"
             onClick={() => {
               if (selectedPage !== 1) {
                 onChangePage(prevPage - 1);
               }
             }}>
            ←
          </div>

          { paginator }
          
          <div className={`item ${(selectedPage === lastPage) ? 'disabled' : ''}`}
             title="Go to next page"
             onClick={() => {
               if (selectedPage !== lastPage) {
                 onChangePage(selectedPage)
               }
             }}>
            →
          </div>
        </div>
      </div>
    );
  }
}

ResultsPaginator.propTypes = {
  totalPages: PropTypes.number.isRequired,
  selectedPage: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
};

export default ResultsPaginator;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/ResultsPaginator.jsx